<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { FileTextIcon, GlobeIcon } from '@solar-icons/vue/linear'

const props = withDefaults(
  defineProps<{
    /** The icon's image URL; the glyph shows when it is missing or fails to load. */
    src?: string
    /** Which glyph stands in: the globe for a web page, the document for a knowledge page. */
    kind?: 'web' | 'knowledge'
  }>(),
  { src: undefined, kind: 'web' },
)

const failed = ref(false)

watch(
  () => props.src,
  () => {
    failed.value = false
  },
)

const showImage = computed(() => Boolean(props.src) && !failed.value)
</script>

<template>
  <span class="icon-sm inline-grid size-8 shrink-0 place-items-center overflow-hidden rounded-2">
    <img
      v-if="showImage"
      :src="src"
      alt=""
      loading="lazy"
      referrerpolicy="no-referrer"
      class="size-full object-cover"
      @error="failed = true"
    />
    <FileTextIcon v-else-if="kind === 'knowledge'" aria-hidden="true" class="text-icon-tertiary" />
    <GlobeIcon v-else aria-hidden="true" class="text-icon-tertiary" />
  </span>
</template>
